import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-item',
  templateUrl: './service-item.component.html',
  styleUrls: ['./service-item.component.scss']
})
export class ServiceItemComponent implements OnInit {
  isSelected : boolean  = false;


  getCurrentServiceImg() {
    // return "http://clem.mobi/img/global_homepage/menu/Recharge.png";
  }

  constructor() {
  }
  ngOnInit() {
   // console.log(this.serviceData);
  }
}